export interface DefaultTheme {
  colors: {
    primary: string;
    background: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
    text: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
    border: {
      primary: string;
      secondary: string;
    };
    pill: {
      primary: string;
      secondary: string;
    };
    nia: {
      primary: string;
      secondary: string;
    };
  };
  spacing: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xxl: string;
  };
  fontSize: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xxl: string;
  };
  icon: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
  };
  button: {
    sm: string;
    md: string;
    lg: string;
  };
  shadow: {
    sm: string;
    md: string;
    lg: string;
  };
  transitions: {
    default: string;
    slow: string;
    fast: string;
  };
  borderRadius: {
    small: string;
    medium: string;
    large: string;
    xl: string;
  };
}

export const lightTheme: DefaultTheme = {
  colors: {
    primary: '#007AFF',
    background: {
      primary: '#ffffff',
      secondary: '#f8f9fa',
      tertiary: '#f0f0f0',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
      tertiary: '#999999',
    },
    border: {
      primary: '#e5e5e5',
      secondary: '#d0d0d0',
    },
    pill: {
      primary: '#f8f9fa',
      secondary: '#e5e5e5',
    },
    nia: {
      primary: '#007AFF',
      secondary: '#0056CC',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
    md: '15px',
    lg: '16px',
    xl: '18px',
    xxl: '24px',
  },
  icon: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '20px',
  },
  button: {
    sm: '32px',
    md: '40px',
    lg: '48px',
  },
  shadow: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.1)',
    md: '0 2px 4px rgba(0, 0, 0, 0.1)',
    lg: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    default: 'all 0.2s ease',
    slow: 'all 0.3s ease',
    fast: 'all 0.1s ease',
  },
  borderRadius: {
    small: '6px',
    medium: '12px',
    large: '18px',
    xl: '24px',
  },
};
